import React from "react"
import { batch } from "@preact/signals-react"

import { AppCurrencyAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { currency, currencyCode, errors } from "@signals"


export default function AppCommonFiltersCurrencyAutocomplete({ ...props }) {
	return <AppCurrencyAutocomplete
		disableClearable
		value={currency.value}
		error={errors.value?.currency}
		onChange={e => currency.value = e.target.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/currencies`}
		onFinishAjax={options => batch(() => {
			currency.value = options.filter(a => a.selected)[0]?.value
			currencyCode.value = options.filter(a => a.selected)[0]?.label
		})}
		{...props}
	/>
}